import { render, staticRenderFns } from "./MetadataHeader.vue?vue&type=template&id=723bb0fc&scoped=true&"
import script from "./MetadataHeader.vue?vue&type=script&lang=js&"
export * from "./MetadataHeader.vue?vue&type=script&lang=js&"
import style0 from "./MetadataHeader.vue?vue&type=style&index=0&id=723bb0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723bb0fc",
  null
  
)

export default component.exports